<template>
    <div>
        <div
            class="d-flex flex-wrap justify-content-end align-items-center mb-3"
        >
            <span class="header-case">Templates for language</span>
            <select v-model="currentLanguage">
                <option v-for="option in options" :value="option">{{
                    langCodeToLabel(option)
                }}</option>
            </select>
        </div>

        <table class="table w-100 mb-3">
            <tr>
                <td class="p-3" scope="row">Type</td>
                <td>
                    <select class="form-control text-capitalize" v-model="newTemplate.type">
                        <option v-for="option in templateTypes" :value="option">{{option}}</option>
                    </select>
                </td>
            </tr>
            <tr>
                <td class="p-3" scope="row">Context</td>
                <td>
                    <select class="form-control text-capitalize" v-model="newTemplate.context">
                        <option v-for="option in templateContext" :value="option">{{option}}</option>
                    </select>
                </td>
            </tr>
            <tr>
                <td class="p-3" scope="row">Text</td>
                <td>
                    <textarea
                        class="form-control"
                        type="text"
                        name=""
                        v-model="newTemplate.text"
                    />
                </td>
            </tr>
        </table>

        <div class="text-right mt-3">
            <button class="btn btn-primary" @click="saveTemplates">Add template for {{ langCodeToLabel(currentLanguage) }} </button>
        </div>

        <div class="accordion" id="placeholderAccordion">
            <div v-for="(template, templateType) in activeTemplate">
                <div class="card">
                    <div class="card-header" :id="templateType">
                    <h2 class="mb-0 row">
                        <div class="col-8">
                            <button class="btn btn-link btn-block text-left text-uppercase collapsed" type="button" data-toggle="collapse" :data-target="'#collapse' + templateType" aria-expanded="false" :aria-controls="'#collapse' + templateType">
                                {{templateType}}
                            <span class="badge brand-primary-badge">{{template.multiple_values.length}}</span>
                            </button>
                        </div>
                    </h2>
                    </div>

                    <div :id="'collapse' + templateType" class="collapse" :aria-labelledby="templateType" data-parent="#placeholderAccordion">
                        <div class="card-body">
                            <table class="table w-100">
                                <thead>
                                    <tr>
                                        <th class="align-middle text-uppercase">
                                            #
                                        </th>
                                        <th class="align-middle text-uppercase">
                                            type
                                        </th>
                                        <th class="align-middle text-uppercase">
                                            text
                                        </th>
                                        <th class="text-uppercase">
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="template.multiple_values">
                                    <tr v-for="(value, index) in template.multiple_values">
                                        <td class="align-middle">
                                            {{value.id}}
                                        </td>
                                        <td class="align-middle text-capitalize">
                                            {{value.type}}
                                        </td>
                                        <td class="align-middle">
                                            {{value.text}}
                                        </td>
                                        <td class="text-right">
                                            <button class="btn btn-default btn-rounded" @click="()=>deletePlaceholder('open',value.id)">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["team_id", "team"],
    watch: {
        team_id: function(newVal, oldVal) {
            this.currentTemplates = null;
            this.getCurrentTemplates();
        },
    },
    data() {
        return {
            currentTemplates: null,
            currentLanguage: "en",
            newTemplate: {
                type: null,
                context: null,
                text: null,
            },
            templateTypes: [
                "open",
                "close",
            ],
            templateContext: [
                "positive",
                "negative",
            ],
            options: [
                "en",
                "nl",
                "de",
                "el",
                "tl",
                "it",
                "es",
                "af",
                "am",
                "ar",
                "bg",
                "cs",
                "fr",
                "pt",
                "sw",
                "sv",
                "tr",
                "ro",
                "ru",
                "uk"
            ],
        };
    },
    mounted() {
        this.getCurrentTemplates();
    },
    computed: {
        activeTemplate()
        {
            if (!this.currentTemplates)
            {
                return null;
            }

            let openingTemplates = this.currentTemplates.filter(templ => templ.language == this.currentLanguage && templ.type == "open");
            let closingTemplates = this.currentTemplates.filter(templ => templ.language == this.currentLanguage && templ.type == "close");

            return {
                open: openingTemplates.length > 0 ? openingTemplates[0] : {multiple_values: []},
                close: closingTemplates.length > 0 ? closingTemplates[0] : {multiple_values: []}
            }
        },
    },
    methods: {
        getCurrentTemplates() {
            if (!Spark.state.user) {
                return;
            }
            axios
                .get(
                    `/api/settings/${this.team_id}/${
                        Spark.state.user.id
                    }/placeholders`
                )
                .then(response => {
                    let templates = response.data.placeholders;
                    this.currentTemplates = templates.filter(template => template.multiple_values !== null).map(template => {
                        template.multiple_values = JSON.parse(template.multiple_values);
                        return template;
                    });
                });
        },
        saveTemplates() {
            let placeholderType = this.newTemplate.type;
            let id = this.activeTemplate[placeholderType].multiple_values.length + 1;

            this.activeTemplate[placeholderType].multiple_values.push(
                {
                    id: id,
                    type: this.newTemplate.context,
                    text: this.newTemplate.text,
                    min_rating: this.newTemplate.min_rating,
                    max_rating: this.newTemplate.max_rating,
                }
            );

            let jsonPlaceholders = { [placeholderType]: JSON.stringify(this.activeTemplate[placeholderType].multiple_values)};

            let payload = {};
            payload.placeholders = jsonPlaceholders;
            payload.language = this.currentLanguage;

            axios
                .post(
                    `/api/settings/${this.team_id}/${
                        Spark.state.user.id
                    }/placeholders`,
                    payload
                )
                .then(response => {
                    let templates = response.data.placeholders;
                    this.currentTemplates = templates.filter(template => template.multiple_values !== null).map(template => {
                        template.multiple_values = JSON.parse(template.multiple_values);
                        return template;
                    });
                    swal(
                        "Awesome!",
                        "Your new settings have been saved!",
                        "success"
                    );
                });
        },
        deletePlaceholder(placeholderType,valueId)
        {

            let multiple_values = this.activeTemplate[placeholderType].multiple_values;

            multiple_values = multiple_values.filter(value => value.id != valueId);

            multiple_values.map(function(value, index)
            {
                value.id = index + 1;
            });

            let jsonPlaceholders = { [placeholderType]: JSON.stringify(multiple_values) };

            let payload = {};
            payload.placeholders = jsonPlaceholders;
            payload.language = this.currentLanguage;

            axios
                .post(
                    `/api/settings/${this.team_id}/${
                        Spark.state.user.id
                    }/placeholders`,
                    payload
                )
                .then(response => {
                    let templates = response.data.placeholders;
                    this.currentTemplates = templates.filter(template => template.multiple_values !== null).map(template => {
                        template.multiple_values = JSON.parse(template.multiple_values);
                        return template;
                    });
                    swal(
                        "Awesome!",
                        "The entry has been deleted.",
                        "success"
                    );
                });
        },
        sanitizeCurrentTemplates()
        {

            if (!this.currentTemplates)
            {
                return;
            }

            this.currentTemplates.map(function(template, index)
            {

                let tempClose = null;
                let tempOpen = null;

                template.value.close.map(function(value, index)
                {
                    if (value === null)
                    {
                        tempClose = template.value.close.splice(index,1);
                    }
                });

                template.value.open.map(function(value, index)
                {
                    if (value === null)
                    {
                        tempOpen = template.value.open.splice(index,1);
                    }
                });

                return {
                    open: tempOpen || template.value.open,
                    close: tempClose || template.value.close,
                };

            });
        },
        launchSettings() {
            this.getCurrentTemplates();
            $(this.$refs.settings_modal).modal("toggle");
        }
    }
};
</script>